
export const getYesterdayDate = () => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday.toISOString().split('T')[0];
};

export const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString();
};

export const exportToCSV = (records: any[]) => {
  const headers = ['ID', 'Title', 'Authors', 'Categories', 'Published Date', 'Abstract', 'PDF URL'];
  const csvData = records.map(record => [
    record.id,
    `"${record.title.replace(/"/g, '""')}"`,
    `"${record.authors.join('; ')}"`,
    `"${record.categories.join(', ')}"`,
    record.publishedDate,
    `"${record.abstract.replace(/"/g, '""')}"`,
    record.pdfUrl
  ]);
  
  const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `arxiv_metadata_${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};
